import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

//
import './index.css';
import App from './App';
// Explicit `brandTheme` file so webpack never resolves this to the
// legacy `./theme/index.js` folder (which exports a ThemeProvider
// function, not a theme object — passing that to MUI silently
// falls back to the default blue/Roboto).
import theme from './brandTheme';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';

// ** Spinner (Splash Screen)
// import Spinner from './@core/components/spinner/Fallback-spinner';

import { LoaderComponent } from './components/loader';
import { ConfirmProvider } from './components/ConfirmDialog';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <HelmetProvider>
      <BrowserRouter>
        <ConfirmProvider>
          <LoaderComponent />
          <App />
        </ConfirmProvider>
      </BrowserRouter>
    </HelmetProvider>
  </ThemeProvider>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
